import MediaCarousel from "./MediaCarousel.vue";

bootVue('.vue-media-carousel', MediaCarousel);
